import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Inversiones } from './pages/Inversiones';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  useEffect(() => {
    document.title = 'Flash & Go | Compra, Venta y Alquiler de Autos';
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="3f8nedijx7b8k">
      <Routes data-id="element-1" data-mp="2rknm2e6yncrv">
        <Route path="/" element={<Home data-id="element-3" data-mp="2rlox4inz7z9l" />} data-id="element-2" data-mp="2rk46h44s90h0" />
        <Route path="/inversiones" element={<Inversiones data-id="element-5" data-mp="2mm2nej7cx15j" />} data-id="element-4" data-mp="2rit1j0zlpmob" />
      </Routes>
    </BrowserRouter>;
}